const v4 = require('uuid/v4');

export const generateTimerId = () => v4().split('-')[0];
export const generateUserId = () => v4().split('-')[0];
